import { setRemoteDefinitions } from '@nx/angular/mf';
import { environment } from './environments/environment';

const manifestFilePath = environment?.run_local_mfe
  ? '/module-federation.manifest.dev.json'
  : environment.production
    ? '/module-federation.manifest.prod.json'
    : '/module-federation.manifest.json';

fetch(manifestFilePath)
  .then((res) => res.json())
  .then((definitions) => {
    setRemoteDefinitions(definitions);
    window['remoteDefinitions'] = definitions;
  })
  .then(() => import('./bootstrap').catch((err) => console.error(err)));
